import React, { useState } from "react";

export default function OutletChip({ component }) {
  const { name, logo_url, brand_logo_url } = component || {};
  const imgSrc = logo_url || "";
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <span className="inline-flex items-center gap-1.5 bg-white/70 border border-[rgba(28,28,32,0.06)] rounded-lg px-2 py-1">
      {imgSrc && !imgFailed && (
        <img
          src={imgSrc}
          alt={name || ""}
          className="h-4 w-auto"
          onError={() => setImgFailed(true)}
        />
      )}
      <span className="text-[12px] font-medium text-[#55555c] whitespace-nowrap">
        {name}
      </span>
    </span>
  );
}